import { useEffect } from "react";

const usePrintPage = (pageTitle: string) => {
  const handleBeforePrint = () => {
    document.body.classList.add("print-mode");
    document.title = pageTitle;
  };

  const handleAfterPrint = () => {
    document.body.classList.remove("print-mode");
    document.title = "Pattern";
  };

  useEffect(() => {
    window.addEventListener("beforeprint", handleBeforePrint);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [pageTitle]); // dependency on pageTitle so that changes to it are reflected
};

export default usePrintPage;
